import { MouseEventHandler, useRef, useState } from "react";
import { Dialog, DialogProps } from "../components/Dialog";

export function useDialog<T>() {
    const [showDialog, setShowDialog] = useState(false);
    const [renderValue, setRenderValue] = useState<T>();
    const [title, setTitle] = useState("");
    const [okButtonText, setOkButtonText] = useState("");

    const [errorMessage, setErrorMessage] = useState<string>();
    const onOkClickHandler = useRef<MouseEventHandler>();

    const show = (_title: string, _okButtonText: string, renderValue?: T, _okClickHandler?: MouseEventHandler) => {
        setTitle(_title);
        setOkButtonText(_okButtonText);

        setErrorMessage(undefined);
        setShowDialog(true);
        setRenderValue(renderValue);

        onOkClickHandler.current = _okClickHandler;
    }
    const handleOkClick: MouseEventHandler = async (event) => {
        if (!onOkClickHandler.current)
            return;
        try {
            await onOkClickHandler.current(event);
            setShowDialog(false);
        } catch (e) {
            setErrorMessage(e instanceof Error ? e.message : "An Error has Occurred: " + e);
        }
    }
    const renderDialog = (renderFunc: (value?: T) => JSX.Element, dialogProps?: Omit<DialogProps, "title" | "show" | "onOkClick" | "onCancelClick" | "okButtonText" | "children">) => {
        return (
            <Dialog title={title}
                className={dialogProps?.className}
                show={showDialog}
                onOkClick={onOkClickHandler.current ? handleOkClick : () => setShowDialog(false)}
                onCancelClick={onOkClickHandler.current ? () => setShowDialog(false) : undefined}
                okButtonText={okButtonText} closeOnOutsideClick={false} {...dialogProps}>

                <div className="p-5">
                    {renderFunc(renderValue)}
                    {errorMessage &&
                        <p>{errorMessage}</p>
                    }
                </div>
            </Dialog>
        );
    }
    return { show, renderDialog };
}
